import { Comment, CommentImage } from './comment'

export * from './comment'

export default { Comment, CommentImage }
